import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import RequestingReducer from "./requesting/RequestingReducer";
import ErrorReducer from "./error/ErrorReducer";
import ToastsReducer from "./toasts/ToastsReducer";
import AuthReducer from "./Auth/AuthReducer";
import InfluencersCampaignReduser from "./influencersCampaigns/InfluencersCampaignReduser";
import influencersCampaignsFilterReduser from "./influencersCampaigns/influencersCampaignsFilterReduser";
import InfluencersActivityReduser from "./influencersActivity/InfluencersActivityReduser";
import InfluencerDashboardReducer from "./influencerDashboard/InfluencerDashboardReducer";
import InfluencerUserFilterReducer from "./influencerUser/InfluencerUserFilterReducer";
import InfluencerUserReducer from "./influencerUser/InfluencerUserReducer";
import InfluencersActivityFilterReduser from "./influencersActivity/InfluencersActivityFilterReduser";
import CampaignMappingReducer from "./campaignMapping/CampaignMappingReducer";
import ActivityTypeReducer from "./influencerActivityType/ActivityTypeReducer";
import ActivityTypeFilterReducer from "./influencerActivityType/ActivityTypeFilterReducer";
import InfluencerPlatformReducer from "./influencerPlatformAccounts/InfluencerPlatformReducer";
import UserByIdReducer from "./user/UserByIdReducer";
import InfluencerUserByIdReducer from "./influencerUser/InfluencerUserByIdReducer";
import StatusReduser from "./status/StatusReduser";
import StatusFilterReduser from "./status/StatusFilterReduser";
import PlatformFilterReducer from "./platform/PlatformFilterReducer";
import PlatformReducer from "./platform/PlatformReducer";
import TagReducer from "./tag/TagReducer";
import TagFilterReducer from "./tag/TagFilterReducer";
import CustomTicketFieldsReducer from "./customticketfields/CustomTicketFieldsReducer";
import CustomTicketFieldsFilterReducer from "./customticketfields/CustomTicketFieldFilterReducer";
import InfluencersCampaignByIdReduser from "./influencersCampaigns/InfluencersCampaignByIdReduser";
import LocationReduser from "./location/LocationReduser";
import UserReducer from "./user/UserReducer";

// eslint-disable-next-line import/no-anonymous-default-export
export default (history) => {
  const reducerMap = {
    error: ErrorReducer.reducer,
    requesting: RequestingReducer.reducer,
    router: connectRouter(history),
    toasts: new ToastsReducer().reducer,
    auth: new AuthReducer().reducer,

    // influencersCampaign
    influencersCampaign: new InfluencersCampaignReduser().reducer,
    influencersCampaignFilter: new influencersCampaignsFilterReduser().reducer,
    InfluencersCampaignById: new InfluencersCampaignByIdReduser().reducer,

    //influencersActivity
    influencersActivity: new InfluencersActivityReduser().reducer,
    influencersActivityFilter: new InfluencersActivityFilterReduser().reducer,

    // influencer Dashboard
    influencerDashboard: new InfluencerDashboardReducer().reducer,

    // influencer user filter
    influencerUser: new InfluencerUserReducer().reducer,
    influencerUserFilter: new InfluencerUserFilterReducer().reducer,

    // influencer platform accounts
    influencerPlatformAccounts: new InfluencerPlatformReducer().reducer,

    // campaign mapping
    campaignMapping: new CampaignMappingReducer().reducer,

    // influencer activity type
    activityType: new ActivityTypeReducer().reducer,
    activityTypeFilter: new ActivityTypeFilterReducer().reducer,

    // influencer user by id
    userById: new UserByIdReducer().reducer,
    user: new UserReducer().reducer,
    influencerUserById: new InfluencerUserByIdReducer().reducer,

    //status
    status: new StatusReduser().reducer,
    statusFilter: new StatusFilterReduser().reducer,

    //platform filter reducer
    platformfilter: new PlatformFilterReducer().reducer,
    platform: new PlatformReducer().reducer,

    // tag reducers
    tag: new TagReducer().reducer,
    tagfilter: new TagFilterReducer().reducer,

    // influencer activity type
    activityType: new ActivityTypeReducer().reducer,
    activityTypeFilter: new ActivityTypeFilterReducer().reducer,

    // custom_ticket_field
    customticketfields: new CustomTicketFieldsReducer().reducer,
    customticketfields_filter: new CustomTicketFieldsFilterReducer().reducer,

    // location
    influencer_location: new LocationReduser().reducer,
  };

  return combineReducers(reducerMap);
};
